module.exports = __webpack_public_path__ + "img/header-engagementRings050Carat@2x.04551b6.jpg";